import { Component, HostBinding, OnInit } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'gcc-loader',
  template: '',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @HostBinding('class.hidden')
  public hidden: boolean;

  constructor(private loader: LoaderService) {}

  public ngOnInit(): void {
    this.loader.shown$.subscribe(isShown => {
      this.hidden = !isShown;
    });
  }
}
